import { createRoleThunks } from "./roleSliceFactory";
import { TENANT_ENDPOINTS, ROLE_COLLECTION_KEYS } from "../types/roles";

const slice = createRoleThunks(
  "tenant",
  TENANT_ENDPOINTS,
  ROLE_COLLECTION_KEYS.tenant
);

export const tenantThunks = {
  fetchResource: slice.fetchResource,
  createResource: slice.createResource,
  updateResource: slice.updateResource,
  runAction: slice.runAction,
};

export const tenantActions = slice.actions;

export default slice.reducer;
